import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter80.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>I possess a diverse skill set in the field of web development and programming. With expertise in HTML, CSS, JavaScript, React, Angular and Nodejs, I can create engaging and user-friendly interfaces. Additionally, my proficiency in C++, Java and JavaScript allows me to build robust and efficient back-end functionalities. I am well-versed in using frameworks like React and Angular to enhance project efficiency. My commitment to continuous learning and my adaptability make me a valuable asset in tackling new challenges and delivering high-quality results.
                          
                        </p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter3} alt="Image" />
                                <h6>React.js</h6>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h6>Angular</h6>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h6>Bootstrap</h6>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h6>CSS</h6>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h6>C++</h6>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h6>C</h6>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h6>Java</h6>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Image" />
                                <h6>JavaScript</h6>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Image" />
                                <h6>Communication and Management</h6>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
